<template>
	<div>
		<model :dialogVisible='dialogVisible' @close="close" width='80%' title='预警信息'>
			<div class="container">
				<dv-scroll-board :config="config" @mouseover='mouseover' style="width:18.65rem;height:7rem;" />
			</div>
		</model>
	</div>
</template>

<script>
import model from './model.vue'
export default {
	components: {
		model
	},
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
		showList: {
			type: Array,
			default: []
		}

	},
	data() {
		return {
			config: {},
			// breederList: []
		};
	},
	watch: {

	},
	created() {
		this.config = {
			header: ['养殖户名称', '养殖户电话', '养殖户地址', '预警耳标', '活畜类别', '活畜品种', '月龄', '当前步数', '当前体温', '预警时间'],
			data: this.showList,
			// align: ['left', 'left', 'left', 'left', 'left','left','right','right','right', 'right'],
			align: ['center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center'],
			// columnWidth: [160, 180, 180, 320, 180, 180, 160],
			headerHeight: 40,
			rowNum: 10,
			waitTime: 2000
		}
	},
	mounted() {

	},

	methods: {

		close() {
			this.$emit('close')
		},
		mouseover() {
			var divs = [...document.querySelectorAll('.container .row-item')]
			divs = [...divs]
			divs.forEach(item => {
				item.childNodes.forEach(it => {
					(it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
				})
			})
		},

	},
};
</script>
<style lang="scss" scoped>
.container {
	padding: 0.25rem;

	::v-deep .ceil:first-child {
		color: #fff !important;
	}
}
</style>